<div class="logo">
  <img ngSrc="/assets/logo/vaggit-logo.jpeg" width="2532" height="2532" alt="Vaggit" priority />
</div>
<div class="side-menu scroll" cdkMenu>
  @for (item of menuItems; track item; let i = $index) {
  <div class="d-flex flex-column" [ngClass]="{
        'active-menu': routerLinkActiveInstance.isActive || isSubMenuOpen('key' + i),
      }">
    <button (click)="toggleSubMenu('key' + i, !!item.subMenus)" #routerLinkActiveInstance="routerLinkActive"
      [routerLinkActive]="['active']" [ngClass]="{
          active: routerLinkActiveInstance.isActive,
          highlight: isSubMenuOpen('key' + i),
        }" (mouseenter)="setHovered(i.toString())" (mouseleave)="clearHovered(i.toString())"
      class="side-menu-item d-flex justify-content-between" cdkMenuItem matTooltip="{{ item.tooltip }}"
      [matTooltipPosition]="'right'" [routerLink]="item.routerLink">
      <div class="d-flex align-items-center gap-2 img-icons">
        @if (item.icon) {
        <mat-icon class="menu-icon" aria-hidden="true">{{ item.icon }}</mat-icon>
        }
        <span class="menu-label">{{ item.displayText }}</span>
      </div>
      <mat-icon *ngIf="item.subMenus" class="submenu-icon" aria-hidden="true">
        {{ isSubMenuOpen('key' + i) ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </button>
    <div *ngIf="isSubMenuOpen('key' + i)" class="d-flex flex-column">
      @for (subItem of item.subMenus; track subItem; let j = $index) {
      <button (click)="toggleSubMenu('key' + i + '_' + j, !!subItem.subMenus)"
        #routerLinkActiveInstance="routerLinkActive" [routerLinkActive]="['active']"
        [class.active]="routerLinkActiveInstance.isActive" (mouseenter)="setHovered(i + '-' + j)"
        (mouseleave)="clearHovered(i + '-' + j)" class="side-menu-item d-flex justify-content-between" cdkMenuItem
        matTooltip="{{ subItem.tooltip }}" [matTooltipPosition]="'right'" [routerLink]="subItem.routerLink">
        <div class="d-flex align-items-center gap-1 img-icons ps-4">
          @if (subItem.icon) {
          <mat-icon class="menu-icon" aria-hidden="true">{{ subItem.icon }}</mat-icon>
          }
          <span class="menu-label">{{ subItem.displayText }}</span>
        </div>
        <mat-icon *ngIf="subItem.subMenus" class="submenu-icon" aria-hidden="true">
          {{ isSubMenuOpen('key' + i + '_' + j) ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>
      <div *ngIf="isSubMenuOpen('key' + i + '_' + j)" class="d-flex flex-column sub-menu">
        @for (subChildItem of subItem.subMenus; track subChildItem; let k = $index) {
        <button #routerLinkActiveInstance="routerLinkActive" [routerLinkActive]="['active']"
          [class.active]="routerLinkActiveInstance.isActive" (mouseenter)="setHovered(i + '-' + j + '-' + k)"
          (mouseleave)="clearHovered(i + '-' + j + '-' + k)" class="side-menu-item" cdkMenuItem
          matTooltip="{{ subChildItem.tooltip }}" [matTooltipPosition]="'right'" [routerLink]="subChildItem.routerLink">
          <div class="d-flex align-items-center gap-1 img-icons ps-1">
            @if (subChildItem.icon) {
            <mat-icon class="menu-icon" aria-hidden="true">{{ subChildItem.icon }}</mat-icon>
            }
            <span class="menu-label">{{
              subChildItem.displayText
              }}</span>
          </div>
        </button>
        }
      </div>
      }
    </div>
  </div>
  }
</div>
<div class="sidebar-footer mt-auto">
  <button class="side-menu-item d-flex align-items-center gap-2" (click)="logout()">
    <mat-icon class="menu-icon" aria-hidden="true">logout</mat-icon>
    <span class="menu-label">Logout</span>
  </button>